/**
 *
 * @component 个人中心/我的方案/项目管理/协作项目详情/施工进度计划tab/进度详情抽屉/动态列表
 *
 **/

import React from 'react';
import { memo, useRef, useState } from 'react';
import {
    Upload,
    message,
    Avatar,
    Image,
    Input,
    Form,
    Modal,
    Button,
    Spin,
    Space,
    Empty,
} from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { getImgPreviewUrl } from '&/utils/common.js';
import dayjs from 'dayjs';
import {
    queryDynamics,
    publishDynamics,
    removeDynamics,
    queryAccessory,
} from '@/api/personCenter/projectSpace1.4';
import BaseModal from '&/components/BaseModal';
import { observer, inject } from 'mobx-react';
import './DynamicList.scss';

function DynamicList(props) {
    useEffect(() => {
        getDynamics(params);
        setAdjunct([]);
    }, []);

    const {
        permission,
        isCreator,
        BASE_CONFIG,
        planId,
        previewPDF,
        appStore,
        previewAudio,
        previewVideo,
        projectId,
    } = props;
    const [dynamics, setDynamics] = useState({ list: [], total: 0 });
    const [listLoading, setListLoading] = useState(false);
    const [params, setParams] = useState({
        pageNum: 9,
        page: 1,
    });

    const isNotFull = () => {
        return (
            dynamics.total >
            (params.page - 1) * params.pageNum + dynamics.list.length
        );
    };
    const moreCount = () => {
        return (
            dynamics.total -
                ((params.page - 1) * params.pageNum + dynamics.list.length) || 0
        );
    };

    // 获取动态列表
    async function getDynamics(params = {}) {
        try {
            setListLoading(true);
            const { data } = await queryDynamics({
                planId,
                projectId,
                ...params,
            });
            setDynamics({
                list: data.list?.map(e => ({ ...e, isShowAll: false })) ?? [],
                total: data.page?.totalList ?? 0,
            });
        } finally {
            setListLoading(false);
        }
    }

    // 显示更早的动态
    const showMore = () => {
        setParams({
            pageNum: dynamics.total,
            page: 1,
        });
        getDynamics({
            pageNum: dynamics.total,
            page: 1,
        });
    };

    //   渲染动态列表里的  附件
    const calcAccessory = (
        accessory = { list: [], count: 0 },
        index,
        messageId
    ) => {
        if (!accessory.list) return;

        function baseCb(type) {
            return el => el.fileType === type;
        }

        const preverImage = () => {
            const list = accessory.list.filter(baseCb('1'));

            return (
                <div className="media-content-image">
                    {list.map((el, idx) => {
                        return (
                            idx < 4 && (
                                <Image
                                    key={el.id}
                                    src={el.thumbUrl}
                                    preview={false}
                                    className="pointer"
                                    data-num={`${
                                        accessory.count - 4 > 0
                                            ? '+' + (accessory.count - 4)
                                            : ''
                                    }`}
                                    onClick={() =>
                                        showAllImage(index, messageId, idx)
                                    }></Image>
                            )
                        );
                    })}
                </div>
            );
        };

        return (
            <>
                {accessory.list.some(baseCb('1')) && preverImage()}

                {accessory.list.some(baseCb('2')) &&
                    accessory.list.filter(baseCb('2')).map(el => (
                        <div
                            key={el.id}
                            className="media-content-video"
                            onClick={() => previewVideo(el.originalUrl)}>
                            <Image
                                preview={false}
                                src={el.thumbUrl}
                                fallback={
                                    require('@/assets/img/userCenter1.4/xqdefault.png')
                                        .default
                                }
                            />
                            <i className="filled icon-play-circle2 play-btn"></i>
                        </div>
                    ))}

                {accessory.list.some(baseCb('3')) &&
                    accessory.list.filter(baseCb('3')).map(el => (
                        <div className="media-content-file" key={el.id}>
                            <section
                                className="file-item text-no-wrap"
                                onClick={() => previewPDF(el.originalUrl)}
                                title={el.describe}>
                                <i className="filled icon-Docment-PDF file-icon"></i>
                                {el.describe}
                            </section>
                        </div>
                    ))}

                {accessory.list.some(baseCb('4')) &&
                    accessory.list.filter(baseCb('4')).map(el => (
                        <div className="media-content-file" key={el.id}>
                            <section
                                className="file-item text-no-wrap"
                                onClick={() => previewAudio(el.originalUrl)}
                                title={el.describe}>
                                <i className="filled icon-Document-Music file-icon"></i>
                                {el.describe}
                            </section>
                        </div>
                    ))}
            </>
        );
    };

    const currentIndex = useRef(0);
    const [groupVisible, setGroupVisible] = useState(false);
    const [currentImages, setcurrentImages] = useState([]);

    const showAllImage = async (idx, messageId, image_idx) => {
        currentIndex.current = image_idx;
        let list = dynamics.list[idx].adjunct.list.map(async item => {
            const params = {
                adjunctId: item.id,
                path: item.url,
                projectId,
            };
            const url = await getImgPreviewUrl(params);
            item.thumbUrl = url;
            return item;
        });
        const imageList = await Promise.all(list);
        setcurrentImages(imageList);
        setGroupVisible(true);

        if (list.length < dynamics.list[idx].adjunct.count) {
            const hideMsg = message.loading('', 0);
            queryAccessory({
                projectId,
                messageId,
            })
                .then(({ data }) => {
                    setcurrentImages(data.list);
                    setDynamics(prev => {
                        const next = { ...prev };
                        next.list[idx].adjunct = data;
                        next.list[idx].isShowAll = true;
                        return next;
                    });
                })
                .finally(hideMsg);
        }
    };

    const calcClass = ({ createDate }) => {
        let classStr = 'status-item';
        const supportRemove = dayjs()
            .subtract(5, 'minute')
            .isAfter(dayjs.unix(createDate), 'minute');
        if (!supportRemove) {
            classStr += ' inner-time';
        }
        return classStr;
    };

    // 删除动态
    const deleteDynamic = messageId => {
        const modal = Modal.confirm({
            title: intl.get('base.warning'),
            icon: <ExclamationCircleOutlined />,
            content: intl.get('directory.deleteConfirm'),
            with: '18.75re,',
            okText: intl.get('base.confirm'),
            cancelText: intl.get('base.cancel'),
            centered: true,
            okButtonProps: { loading: false },
            onOk: async () => {
                modal.update({ okButtonProps: { loading: true } });
                try {
                    await removeDynamics({ messageId, projectId });
                    getDynamics();
                    message.success(intl.get('templateSettings.deleteSuccess'));
                } finally {
                    modal.update({ okButtonProps: { loading: false } });
                }
            },
        });
    };

    const [sendLoading, setSendLoading] = useState(false);
    const [describe, setDescribe] = useState(''); // 发布动态的描述
    const [adjunct, setAdjunct] = useState([]); // 发布动态的附件
    const [sendVisible, setSendVisible] = useState(false); //发送动态框输入

    const openPublish = () => {
        setSendVisible(true);
    };

    const closePublish = () => {
        setSendVisible(false);
    };

    // 提交发布动态
    function onPublish() {
        let realFiles = adjunct.filter(e => e.status === 'done');
        if (!realFiles.length && !describe) return;
        setSendLoading(true);
        publishDynamics({
            adjunct: realFiles.map(e => ({
                name: e.name || e.response.fileName,
                url: e.response.filePath,
                size: e.response.fileSize,
                fileType: e.response.fileType,
            })),
            describe,
            projectId,
            planId,
        })
            .then(({ msg }) => {
                message.success(msg);
                closePublish();
                setParams({
                    pageNum: dynamics.total + 1,
                    page: 1,
                });
                const addParams = {
                    page: params.page,
                    pageNum: Number(params.pageNum) + 1,
                };
                getDynamics(addParams);
                setDescribe();
                setAdjunct([]);
            })
            .finally(() => {
                setSendLoading(false);
            });
    }

    const ACCEPT_IMAGE = ['image/png', 'image/jpg', 'image/jpeg', 'image/bmp'];
    const ACCEPT_PDF = ['application/pdf'];
    const [currentUploadType, setCurrentUploadType] = useState('image');

    const selectUpdateType = type => {
        setCurrentUploadType(type);
    };
    const IMG_MAX_COUNT = 100;
    const [imgAccept, setImgAccept] = useState(ACCEPT_IMAGE.toString(','));
    const CONFIGS = {
        ...BASE_CONFIG,
        fileList: adjunct,
        maxCount: IMG_MAX_COUNT,
        onPreview(file) {
            let url = file.response
                ? file.response.fileLink
                : window.URL.createObjectURL(file.originFileObj);
            if (file.status !== 'error') {
                currentIndex.current = 0;
                setcurrentImages([
                    { ...file, id: file.uid, url, thumbUrl: url },
                ]);
                setGroupVisible(true);
            }
        },
        accept: imgAccept,
        onChange({ fileList }) {
            fileList = fileList.map(file => {
                if (file.response) {
                    file.url = file.response.url;
                }
                return file;
            });
            setAdjunct(fileList);
        },
        async beforeUpload(file, fileList) {
            setImgAccept(ACCEPT_IMAGE.toString(','));
            let ERROR_MSG = [];
            const isInclude = ACCEPT_IMAGE.includes(file.type);
            if (!isInclude)
                ERROR_MSG.push(intl.get('projectSpace.uploadLimit'));

            let fileLength =
                fileList.findIndex(item => item.uid === file.uid) + 1;
            if (fileLength + adjunct.length > IMG_MAX_COUNT) {
                if (fileLength + adjunct.length === IMG_MAX_COUNT + 1) {
                    ERROR_MSG.push(
                        intl.get('userCenter.uploadMaterialDesc').split(',')[3]
                    );
                }
            }
            ERROR_MSG = ERROR_MSG.map((str, idx) => <p key={idx}>{str}</p>);
            !!ERROR_MSG.length && message.error(ERROR_MSG);
            return !ERROR_MSG.length || Upload.LIST_IGNORE;
        },
    };
    const [pdfAccept, setPdfAccept] = useState(ACCEPT_PDF.toString(','));
    const PDF_MAX_COUNT = 5;
    const CONFIGS2 = {
        ...BASE_CONFIG,
        fileList: adjunct,
        maxCount: PDF_MAX_COUNT,
        accept: pdfAccept,
        onPreview(file) {
            if (file.response) {
                previewPDF(file.response.fileLink || file.url);
                return;
            }
        },
        onChange({ fileList }) {
            fileList = fileList.map(file => {
                if (file.response) {
                    file.url = file.response.url;
                }
                return file;
            });
            setAdjunct(fileList);
        },
        async beforeUpload(file, fileList) {
            let ERROR_MSG = [];
            setPdfAccept(ACCEPT_PDF.toString(','));
            let isInclude = ACCEPT_PDF.includes(file.type);
            if (!isInclude) {
                ERROR_MSG.push(intl.get('projectSpace.pdfFileCheck'));
            }

            let fileLength =
                fileList.findIndex(item => item.uid === file.uid) + 1;
            if (fileLength + adjunct.length > PDF_MAX_COUNT) {
                if (fileLength + adjunct.length === PDF_MAX_COUNT + 1) {
                    ERROR_MSG.push(
                        intl.get('projectSpace.maxFileCheck', {
                            max: PDF_MAX_COUNT,
                        })
                    );
                }
                return false;
            }
            ERROR_MSG = ERROR_MSG.map((str, idx) => <p key={idx}>{str}</p>);
            !!ERROR_MSG.length && message.error(ERROR_MSG);
            return !ERROR_MSG.length || Upload.LIST_IGNORE;
        },
    };
    const { Item } = Form;

    return (
        <div className="all-status">
            <header className="all-status-header">
                {intl.get('projectSpace.dynamicsTotal', {
                    total: dynamics.total,
                })}
                <div
                    type="link"
                    className={`native-link ${
                        !(permission.includes('planDynamicSave') || isCreator)
                            ? 'type--disabled'
                            : ''
                    }`}
                    onClick={
                        permission.includes('planDynamicSave') || isCreator
                            ? openPublish
                            : undefined
                    }>
                    {intl.get('projectSpace.dynamicsPublish')}
                </div>
            </header>
            {listLoading ? (
                <Spin
                    spinning={listLoading}
                    style={{
                        width: '100%',
                        paddingTop: '10%',
                    }}></Spin>
            ) : (
                <>
                    {isNotFull() && (
                        <div className="view-more" onClick={showMore}>
                            {intl.get('projectSpace.viewHistory')}
                            <a className="native-link">{moreCount()}</a>
                            {intl.get('projectSpace.dynamicsNum', { num: '' })}
                        </div>
                    )}

                    {!+dynamics.total ? (
                        <Empty
                            image={
                                require('@/assets/img/userCenter1.4/emptyydata-object.png')
                                    .default
                            }
                            imageStyle={{
                                height: 160,
                                marginTop: '10%',
                            }}
                            description={
                                <div className="hint-message">
                                    {intl.get('projectSpace.noDynamics')}
                                </div>
                            }></Empty>
                    ) : (
                        <div className="status-items">
                            {dynamics.list.map((e, index) => (
                                <section key={e.id} className={calcClass(e)}>
                                    <Avatar
                                        src={e.head_url}
                                        style={{
                                            width: '1.5rem',
                                            height: '1.5rem',
                                        }}>
                                        {e.username?.substr(0, 1)}
                                    </Avatar>
                                    <div
                                        className="text-no-wrap"
                                        title={e.username}>
                                        {e.username}
                                    </div>
                                    <div className="status-item-time">
                                        {appStore.userInfo.userId ===
                                            e.createId && (
                                            <a
                                                className="native-link delete-dynamic"
                                                onClick={() =>
                                                    deleteDynamic(e.id)
                                                }>
                                                {intl.get('base.delete')}
                                            </a>
                                        )}
                                        {dayjs(e.createDate * 1e3).format(
                                            'YYYY-MM-DD HH:mm'
                                        )}
                                    </div>
                                    <div className="status-item-content">
                                        {e.describe}
                                        {calcAccessory(e.adjunct, index, e.id)}
                                    </div>
                                </section>
                            ))}
                        </div>
                    )}
                </>
            )}

            <BaseModal
                title={intl.get('projectSpace.dynamicsPublish')}
                width="32.625rem"
                wrapClassName="describe"
                footer={
                    <Space>
                        <Button onClick={closePublish}>
                            {intl.get('base.cancel')}
                        </Button>
                        <Button
                            onClick={onPublish}
                            loading={sendLoading}
                            disabled={
                                !adjunct.filter(e => e.status === 'done')
                                    .length && !describe
                            }
                            type="primary">
                            {intl.get('base.confirm')}
                        </Button>
                    </Space>
                }
                visible={sendVisible}
                onCancel={closePublish}>
                <Form className="form-group" labelCol={{ span: 5 }}>
                    <Item label={intl.get('projectSpace.dynamicsContent')}>
                        <Input.TextArea
                            value={describe}
                            allowClear
                            showCount
                            maxLength={255}
                            onChange={({ target }) => setDescribe(target.value)}
                            autoSize={{ minRows: 4, maxRows: 4 }}
                        />
                    </Item>
                    <Item
                        label={intl.get('base.uploadAttachment')}
                        className="accessoryBox">
                        {(currentUploadType === 'image' || !adjunct.length) && (
                            <Upload
                                className={`${
                                    adjunct.length ? 'full uploads' : 'uploads'
                                }`}
                                onClick={() => setImgAccept('')}
                                {...CONFIGS}>
                                <Button
                                    onClick={e => selectUpdateType('image')}>
                                    {intl.get('base.uploadPic')}
                                </Button>
                            </Upload>
                        )}
                        {(currentUploadType === 'pdf' || !adjunct.length) && (
                            <Upload
                                {...CONFIGS2}
                                onClick={() => setPdfAccept('')}
                                className={`${
                                    adjunct.length ? 'full uploads' : 'uploads'
                                }`}>
                                <Button onClick={e => selectUpdateType('pdf')}>
                                    {intl.get('base.uploadPDF')}
                                </Button>
                            </Upload>
                        )}
                    </Item>
                </Form>
            </BaseModal>

            <div style={{ display: 'none' }}>
                <Image.PreviewGroup
                    preview={{
                        visible: groupVisible,
                        current: currentIndex.current,
                        onVisibleChange: (visible, prevVisible) => {
                            setGroupVisible(visible);
                        },
                    }}>
                    {currentImages.map(el => {
                        return <Image key={el.id} src={el.thumbUrl}></Image>;
                    })}
                </Image.PreviewGroup>
            </div>
        </div>
    );
}

export default inject('appStore')(memo(observer(DynamicList)));
